module.exports = __webpack_public_path__ + "assets/retina_SquareInSquareDetailed.9c9882b7a72b594176ccaaf9fb312981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_SquareInSquareDetailed.png
// module id = 723
// module chunks = 0